"use-client"

import { adminGetArtifact, AdminGetArtifactData, getWebPage } from "@/api";
import { Request } from "../components/CRUD"
import { useEffect, useState } from "react";
import { appState } from "@/app/appState";
import { page_artifact } from "@/app/typing/artifacts";
import { ForwardRefEditor } from "@/components/richtext/ForwardRefEditor";
import { codeBlockPlugin, codeMirrorPlugin, headingsPlugin, listsPlugin, quotePlugin, tablePlugin, thematicBreakPlugin, toolbarPlugin } from "@mdxeditor/editor";
import { observer } from "mobx-react-lite";
import { PublicPageShell } from "@/components/PublicPageShell";





export const WebPage = observer(({ id, path }: { id: number, path: string }) => {



    const [loading, setLoading] = useState<boolean>(false)
    const [pageArtifact, setPageArtifact] = useState<page_artifact>()


    const getArtifact = Request<AdminGetArtifactData, any>(
        getWebPage,
        () => ({
            body: {
                id: id!
            },
        }),
        setLoading,
        (data: any) => {
            setPageArtifact(data.artifact);
        },
        (error) => {
            setPageArtifact(undefined)
            appState.setModal({ title: appState.t("common.error"), body: appState.t("marketing.errorGetPage") });
        },
        () => id != undefined && id > 0,
    )

    useEffect(() => {
        getArtifact()
    }, [path])

    return (
        <PublicPageShell
            footerLanguageSwitcher
            contentClassName="justify-center items-center p-3"
        >
            {loading ? null : (
                <div className="public-card">
                    <ForwardRefEditor
                        markdown={pageArtifact?.content ?? ""}
                        readOnly={true}
                        plugins={[
                            headingsPlugin(),
                            listsPlugin(),
                            quotePlugin(),
                            thematicBreakPlugin(),
                            tablePlugin(),
                            codeBlockPlugin({ defaultCodeBlockLanguage: "" }),
                            codeMirrorPlugin({ codeBlockLanguages: { "": "Plain Text" } }),
                        ]}
                        contentEditableClassName="w-full serif"
                    />
                </div>
            )}
        </PublicPageShell>
    )
})